import { z } from "zod";

import { multiSelectResponseSchema } from "../../common/schemaHelper";

/**
 * Mental Health History validation schema
 * Validates the entire mentalHealthHistory category
 */

export const mentalHealthHistoryValidation = z.object({
  mentalHealthConcern: z
    .array(multiSelectResponseSchema)
    .min(1, "Please select at least one option"),
  motivationAndReadiness: z.string().min(1, { message: "Motivation and Readiness is required" }),
});

export default mentalHealthHistoryValidation;
